var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ImageSkeleton"},[(_vm.isGallery)?_c('i',{staticClass:"fas fa-images"}):_c('i',{staticClass:"fas fa-image"}),_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }